export const dotsFormat = (x: number, digits?: number) => {
  let _digits = digits;
  if (digits === 0) _digits = undefined;
  const floatString = _digits !== undefined ? Math.round(x)?.toFixed(_digits) : Math.round(x)?.toString();
  const decimalDigits = _digits !== undefined ? floatString?.substring(floatString.length - 1 - _digits)?.substring(1) : undefined;
  const intString = _digits !== undefined ? floatString?.substring(0, floatString.length - 1 - _digits) : floatString;

  return `${intString?.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${decimalDigits !== undefined ? `,${decimalDigits}` : ''}`;
};

export const fixedDigitsFormat = (x: number, digits: number) => {
  const floatString = x?.toFixed(digits);
  const decimalDigits = floatString?.substring(floatString.length - 1 - digits)?.substring(1);
  const intString = digits !== 0 ? floatString?.substring(0, floatString.length - 1 - digits) : floatString;
  if (intString === '-0' && decimalDigits === '00') return '0,00';
  return `${intString?.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${digits !== 0 ? `,${decimalDigits}` : ''}`;
};

export const currencyFixedDigitsFormat = (
  n: number,
  digits = 2,
  currency: {
    value: string;
    currencyPosition?: string;
  }
) => {
  if (currency.currencyPosition === 'left' && currency.currencyPosition !== undefined) {
    return `${currency.value} ${fixedDigitsFormat(n, digits)}`;
  } else {
    return `${fixedDigitsFormat(n, digits)} ${currency.value}`;
  }
};

export const getLargestRemainder = (values: number[], desiredSum: number, notFullValues?: boolean) => {
  let sum = 0;
  let valueParts = values.map((value: number, index: number) => {
    // Get rounded down integer values.
    const integerValue = value | 0;
    sum += integerValue;
    return {
      integer: integerValue, // Integer part of the value
      decimal: value % 1, // Decimal part of the value
      originalIndex: index, // Used to return values in original order.
    };
  });
  if (sum !== desiredSum) {
    // Sort values by integer part
    valueParts = valueParts.sort((a, b) => b.integer - a.integer);

    const diff = desiredSum - sum;
    let i = 0;

    // Distribute the difference.
    while (i < diff && valueParts[i]) {
      // @ts-ignore: noUncheckedIndexedAccess
      valueParts[i].integer++;
      i++;
    }
  }
  // if notFullValues is true, we have more than one element and one of them has interger === 100, we need to change 100% to 99% and the others to 0.5%
  if (notFullValues && valueParts.length > 1 && valueParts.find((v) => v.integer === 100)) {
    valueParts = [...valueParts].map((value) => {
      if (value.integer === 100) {
        return {
          integer: 99.1,
          decimal: value.decimal,
          originalIndex: value.originalIndex,
        };
      }
      return {
        integer: 0,
        decimal: value.decimal,
        originalIndex: value.originalIndex,
      };
    });
  }
  return valueParts.sort((a, b) => a.originalIndex - b.originalIndex);
};

export const getLargestRemainderPercentage = (valuesObj: object, isDonutChart?: boolean, notFullValues?: boolean) => {
  let total = 0;
  Object.keys(valuesObj).map(
    // eslint-disable-next-line no-return-assign
    (k) =>
      (total +=
        // @ts-ignore
        valuesObj[k])
  );
  // Calculate singlePercValue based on total and push it into valuesPerc
  const valuesPerc: number[] = [];
  // eslint-disable-next-line array-callback-return
  Object.keys(valuesObj).map((k) => {
    const singlePercValue = Math.floor(
      // @ts-ignore
      (valuesObj[k] / total) * 100
    );
    // if is a donut chart and the value is < 1 we set it to 0.5 in order to show it in the chart (values equal to 0 are not shown but the label is present)
    valuesPerc.push(singlePercValue === 0 && isDonutChart ? 0.5 : singlePercValue);
  });
  return getLargestRemainder(valuesPerc, 100, notFullValues);
};
